import DResultsSports from './DResultsSports'

export default DResultsSports
